import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
const CircleCheckmark = ({ disabled = false, highligted = false, size = 20 })=>{
    const fillOpacity = disabled ? '0.38' : '1';
    const getFillColor = ()=>{
        if (disabled) {
            return '#323338';
        }
        if (highligted) {
            return '#00D2D2';
        }
        return '#676879';
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("svg", {
            width: size,
            height: size,
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.99883 2.30005C5.74623 2.30005 2.29883 5.74746 2.29883 10C2.29883 14.2526 5.74623 17.7 9.99883 17.7C14.2514 17.7 17.6988 14.2526 17.6988 10C17.6988 5.74746 14.2514 2.30005 9.99883 2.30005ZM8.89909 12.6089C8.60538 12.9026 8.12918 12.9026 7.83547 12.6089L5.82989 10.6033C5.53617 10.3096 5.53617 9.83339 5.82989 9.53968C6.1236 9.24597 6.59979 9.24597 6.89351 9.53968L8.36728 11.0135L12.348 7.03271C12.6417 6.739 13.1179 6.739 13.4116 7.03271C13.7054 7.32642 13.7054 7.80262 13.4116 8.09633L8.89909 12.6089Z",
                fill: getFillColor(),
                fillOpacity: fillOpacity
            })
        })
    });
};
CircleCheckmark.propTypes = {
    disabled: PropTypes.bool,
    size: PropTypes.number,
    className: PropTypes.string
};
export default CircleCheckmark;
